"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.attachmentImagePreview = attachmentImagePreview;
var _materialSymbols = require("@design/icons/material-symbols");
var _StoredImage = require("../chat/StoredImage");
var _chatMessageFiles = require("../../schemas/chat-message-files");
var _jsxRuntime = require("react/jsx-runtime");
function attachmentImagePreview(fileName, storageUrl) {
  if (!storageUrl || !(0, _chatMessageFiles.isImageFileName)(fileName)) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_StoredImage.StoredImage, {
    storedImage: {
      storageUrl: storageUrl,
      fileName: fileName
    },
    className: "size-full",
    placeholder: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ImageIcon, {}),
    "data-sentry-element": "StoredImage",
    "data-sentry-component": "attachmentImagePreview",
    "data-sentry-source-file": "chat-composer-image-preview.tsx"
  });
}